import { render, staticRenderFns } from "./Add_table_jump.vue?vue&type=template&id=3beb2b50"
import script from "./Add_table_jump.vue?vue&type=script&lang=js"
export * from "./Add_table_jump.vue?vue&type=script&lang=js"
import style0 from "./Add_table_jump.vue?vue&type=style&index=0&id=3beb2b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports